import { render, staticRenderFns } from "./lawRegister.vue?vue&type=template&id=6b8f387e"
import script from "./lawRegister.vue?vue&type=script&lang=js"
export * from "./lawRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8f387e')) {
      api.createRecord('6b8f387e', component.options)
    } else {
      api.reload('6b8f387e', component.options)
    }
    module.hot.accept("./lawRegister.vue?vue&type=template&id=6b8f387e", function () {
      api.rerender('6b8f387e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/law/register/lawRegister.vue"
export default component.exports